export default __webpack_public_path__ + "static/media/avatar_elephant4.cdd41b45.mp3";